import { render, staticRenderFns } from "./InventoryBlockSelect.vue?vue&type=template&id=0356c185&"
import script from "./InventoryBlockSelect.vue?vue&type=script&lang=js&"
export * from "./InventoryBlockSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports